class AnimationDelay {
  constructor({stepsPerFrame} = {}) {
    this.N = stepsPerFrame || 1;
    this.s = 0;
  }
  delay() {
    // console.log(this.N)
    if (this.s < this.N) {
      this.s += 1;
      return new Promise(resolve => {
        resolve();
      });
    }
    this.s = 0;
    return new Promise(resolve => {
      requestAnimationFrame(resolve);
    })
  }
  setStepsPerFrame(n) {
    this.N = n;
  }
}
export default AnimationDelay;


// WEBPACK FOOTER //
// ./src/utils/AnimationDelay.js